export default __webpack_public_path__ + "static/media/upward.fb901478.svg";